import { NeoModel } from "@singularsystems/neo-core";
import BaseCheckQueryCommand from "./BaseCheckQueryCommand";

@NeoModel
export default class CreateCheckQueryCommand extends BaseCheckQueryCommand {
}